import dataStoreFactory from '~utils/data-store-factory';
import { createContext } from 'react';
import { UploadsPermissionsFranchisesAPI } from '../api/uploads-permissions-franchises';
export const UploadsPermissionsFranchisesStore = dataStoreFactory(UploadsPermissionsFranchisesAPI);
export const uploadsPermissionsFranchisesStore = new UploadsPermissionsFranchisesStore();
export const UploadsPermissionsFranchisesStoreContext = createContext(uploadsPermissionsFranchisesStore);
